import React from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';
import { device } from 'utils/device';

const SearchButton = (props) => (
  <>
    <StyledButton {...props}>
      <Icon /> Search
    </StyledButton>
  </>
);

const StyledButton = styled.button`
  background-color: ${({ theme }) => theme.palette.primary[0]};
  color: ${({ theme }) => theme.palette.primary[4]};
  border: none;
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;

  @media ${device.mobileL} {
    text-align: left;
    margin: 1rem;
  }
`;

const Icon = styled(FaSearch)`
  font-size: 1.1rem;
  margin-right: 0.2rem;
`;

export default SearchButton;
